export default "__VITE_ASSET__CdKvWmUP__"